import { extendTheme } from "@chakra-ui/react";

const colors = {
  orange: {
    100: "#FEF9F2",
    400: "#FF9F1A",
    500: "#F28D00",
    600: "#B36800",
  },
  gray: {
    50: "#FAF9F8",
    500: "#E0DED8",
    700: "#696969",
  },
  brand: {
    500: "orange.500",
  },
};

const fonts = {
  body: '"akzidenz-grotesk","Helvetica Neue",Helvetica,Arial,sans-serif',
  heading: '"akzidenz-grotesk","Helvetica Neue",Helvetica,Arial,sans-serif',
};

const fontSizes = {
  sm: "14px",
  md: "16px",
  lg: "20px",
  xl: "22px",
  "2xl": "25px",
  "3xl": "36px",
  "4xl": "54px",
};

const lineHeights = {
  shorter: 1.18,
  short: 1.35,
  tall: 1.65,
};

const fontWeights = {
  light: 300,
  normal: 400,
  bold: 600,
};

const shadows = {
  outline: "0 0 0 3px rgba(242, 141, 0, 0.2)",
};

const styles = {
  global: {
    body: {
      height: "100%",
      bg: "white",
    },
    p: {
      marginTop: "0.625rem",
      marginBottom: "0.625rem",
    },
  },
};

const components = {
  Heading: {
    baseStyle: {
      fontWeight: "light",
    },
  },
  Input: {
    variants: {
      outline: {
        field: {
          borderRadius: 0,
          borderColor: "#000",
          boxShadow: "0 0 0 1px #000",
          _hover: {
            borderColor: "#000",
          },
          _focus: {
            boxShadow: `0 0 0 1px ${colors.orange["500"]}`,
            borderColor: "orange.500",
          },
          _placeholder: {
            color: "gray.700",
          },
        },
      },
    },
  },
  Select: {
    variants: {
      outline: {
        field: {
          borderRadius: 0,
          borderColor: "#000",
          boxShadow: "0 0 0 1px #000",
          _hover: {
            borderColor: "#000",
          },
          _focus: {
            boxShadow: `0 0 0 1px ${colors.orange["500"]}`,
            borderColor: "orange.500",
          },
          _placeholder: {
            color: "gray.700",
          },
        },
      },
    },
  },
  Table: {
    variants: {
      striped: {
        tbody: {
          tr: {
            _odd: {
              td: {
                background: colors.gray["50"],
              },
            },
            td: {
              background: "white",
              border: 0,
            },
          },
        },
        thead: {
          borderBottom: "2px solid",
        },
        th: {
          color: "black",
          fontWeight: "normal",
          fontSize: "sm",
          textTransform: "none",
          border: 0,
        },
      },
    },
  },
  Radio: {
    parts: ["control"],
    baseStyle: {
      control: {
        borderColor: "black",
        borderWidth: "1px",
        _checked: {
          borderWidth: "2px",
          borderColor: "orange.500",
          color: "orange.500",
          _hover: {
            borderColor: "orange.500",
          },
        },
      },
    },
    sizes: {
      md: {
        control: {
          _checked: {
            _before: {
              border: "3px solid white",
              width: "100%",
              height: "100%",
            },
          },
          width: 6,
          height: 6,
        },
      },
    },
  },
  Textarea: {
    variants: {
      outline: {
        borderWidth: "2px",
        borderRadius: 0,
        borderColor: "black",
        _hover: {
          borderColor: "black",
        },
        _focus: {
          borderColor: "black",
          boxShadow: "outline",
        },
      },
    },
  },
};

export const theme = extendTheme({
  colors,
  styles,
  components,
  fonts,
  fontSizes,
  lineHeights,
  fontWeights,
  shadows,
});
